export default "__VITE_ASSET__DdkBSkVc__"